import {
  CATEGORY_LOADING,
  CATEGORY_LOADED,
  CATEGORY_LOAD_ERROR,
} from "../../actions/registry/registry.category.actions";
import { reducerFromMap } from "../../libs/helpers/reducers";

const reducer = {
  /*
   * CATEGORY LIST
   */
  [CATEGORY_LOADING]: (state) => ({
    ...state,
    loading: true,
  }),
  [CATEGORY_LOADED]: (state, { data }) => ({
    ...state,
    loading: false,
    data: data.data,
  }),
  [CATEGORY_LOAD_ERROR]: (state, { data }) => ({
    ...state,
    loading: false,
    error: data,
  }),
};

export default reducerFromMap(reducer, {
  data: [],
});
